import PropTypes from "prop-types";
import React from "react";

import { fileNamify } from "../../services/text-formatter.service";
import { cssValueType } from "../../services/types.service";
import buildAssetsUrl from "../../util/strings/buildAssetsUrl";
export const Brand = (props) => {
  const style = {
    height: props.height,
    width: props.width,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  return (
    <div style={style}>
      <img
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
        }}
        src={buildAssetsUrl(`${fileNamify(props.client)}/brand.svg`)}
        alt="Home"
      />
    </div>
  );
};

Brand.propTypes = {
  height: cssValueType,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  client: PropTypes.string,
};

Brand.defaultProps = {
  height: 43,
  width: 43,
  client: "superpedestrian",
};
